import { API_URL } from "./env";

const API_BASE = API_URL;

async function parseJsonResponse(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const detail = data.detail ?? data.message ?? res.statusText;
        throw new Error(
            typeof detail === "string" ? detail : "Request failed.",
        );
    }
    return data;
}

export async function fetchPricingQuote({ planId, licenseCount, yearly }) {
    const res = await fetch(`${API_BASE}/api/payments/quote`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            plan_id: planId,
            license_count: licenseCount,
            yearly,
        }),
    });
    return parseJsonResponse(res);
}

export async function createCheckoutSession(payload) {
    const res = await fetch(`${API_BASE}/api/payments/checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            plan_id: payload.planId,
            license_count: payload.licenseCount,
            yearly: payload.yearly,
            name: payload.name,
            email: payload.email,
            company: payload.company,
            phone: payload.phone || null,
            message: payload.message || null,
            _hp: payload._hp ?? "",
            _form_started_at: payload._form_started_at ?? Date.now(),
        }),
    });
    return parseJsonResponse(res);
}

export async function verifyPaymentReturn(searchParams) {
    const params = { ...searchParams };
    const hasZohoSession = Boolean(params.payments_session_id);
    const looksLikePayu =
        params.provider === "payu" ||
        Boolean(params.txnid) ||
        Boolean(params.mihpayid) ||
        (!hasZohoSession &&
            ["success", "failure", "pending", "failed"].includes(
                String(params.status || "").toLowerCase(),
            ));
    if (looksLikePayu && !params.provider) {
        params.provider = "payu";
    }
    const query = new URLSearchParams(params).toString();
    const res = await fetch(`${API_BASE}/api/payments/verify?${query}`);
    return parseJsonResponse(res);
}
